/**
 * Tipi TypeScript per Batch OCR API
 * Corrispondono agli schemi Pydantic del backend
 */

// === ENUMS ===

export enum BatchOCRJobStatus {
    SUBMITTED = "submitted",
    IN_PROGRESS = "in_progress",
    COMPLETED = "completed",
    PARTIALLY_COMPLETED = "partially_completed",
    FAILED = "failed",
}

export enum BatchOCRItemStatus {
    PENDING = "pending",
    SUBMITTED = "submitted",
    IN_QUEUE = "in_queue",
    IN_PROGRESS = "in_progress",
    COMPLETED = "completed",
    FAILED = "failed",
}

// === RESPONSE INTERFACES ===

export interface BatchOCRItemResponse {
    item_id: string;
    training_document_id: string;
    runpod_job_id: string | null;
    status: BatchOCRItemStatus;
    error_message: string | null;
    has_ocr_output: boolean;
}

export interface BatchOCRJobResponse {
    batch_job_id: string;
    batch_name: string | null;
    total_documents: number;
    completed_documents: number;
    failed_documents: number;
    status: BatchOCRJobStatus;
    created_at: string;
    completed_at: string | null;
    items?: BatchOCRItemResponse[];
}

// === REQUEST INTERFACES ===

export interface BatchOCRSubmitRequest {
    training_document_ids: string[];
    batch_name?: string;
}

// === FILTER INTERFACES ===

export interface BatchOCRListFilters {
    skip?: number;
    limit?: number;
}

export interface BatchOCRGetParams {
    refresh?: boolean;
}

// === TYPE ALIASES ===

export type BatchOCRJobSummary = Omit<BatchOCRJobResponse, "items">;
